import React from 'react';
import {observer} from 'mobx-react';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';
import {FormError, CheckboxWithLabel} from 'components';
import {Modal, ModalButtons} from 'components/modals';

const DeclineCoverageModal = observer(({uiState}) => {
  const {
    declineCoverageModalOpen,
    currentEligibilityRecord,
    agreeToDeclineCoverage,
    employee,
    errors
  } = uiState;

  return (
    <Modal isOpen={declineCoverageModalOpen} onHide={() => uiState.closeModals()} size='md'>
      <div className='h2 medium center mb3'>
        <FormattedMessage id='components.additional_coverage.Waiver of Excess Coverage' />
      </div>
      <div>
        <FormattedMessage
          id='components.additional_coverage.WAIVER_TEXT_ONE'
          values={{
            employeeName: <b>{employee.name}</b>,
            coverageType: t(`models.coverage_types.${currentEligibilityRecord.coverageType}`)
          }}
        />
      </div>
      <div className='my2'>
        <FormattedMessage id='components.additional_coverage.WAIVER_TEXT_TWO'/>
      </div>
      <div className='my2'>
        <FormattedMessage id='components.additional_coverage.WAIVER_TEXT_THREE'/>
      </div>
      <div className='my2'>
        <CheckboxWithLabel 
          checked={agreeToDeclineCoverage} 
          onChange={e => uiState.toggleDeclineCoverageAgreement(e.checked)} 
          label='components.additional_coverage.WAIVER_TEXT_FOUR' />
        <FormError message={errors.agreeToDeclineCoverage} />
      </div>

      <ModalButtons 
        onSave={() => uiState.submitDeclinedCoverage()} 
        onCancel={() => uiState.closeModals()} />
    </Modal>
  );
});

export default DeclineCoverageModal;
